import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { DOCUMENTO_INSTRUCAO_DESPACHO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

async function fetchAll() {
  return doGetQCXRequest([
    DOCUMENTO_INSTRUCAO_DESPACHO_ENDPOINT
  ]);
}

async function fetchById(id) {
  return doGetQCXRequest([
    DOCUMENTO_INSTRUCAO_DESPACHO_ENDPOINT,
    id
  ]);
}

const documentoInstrucaoDespachoAPI = {
  fetchAll,
  fetchById,
};

export {
  documentoInstrucaoDespachoAPI,
  fetchAll,
  fetchById,
};
